import { ContactViewModel } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { EntityChip } from '../../../../components/chips/EntityChip';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	contacts: ContactViewModel[];
	maxContacts: number;
	totalContacts: number;
}

export class Contacts extends React.PureComponent<IProps> {
	public render() {
		const { totalContacts, contacts, maxContacts, className } = this.props;

		const overflowCount = totalContacts - (maxContacts < contacts.length ? maxContacts : contacts.length);
		const visibleContacts = contacts.length <= maxContacts ? contacts : contacts.slice(0, maxContacts);

		return (
			<div className={`${css(styleSheet.container)} campaign-contacts ${className || ''}`}>
				<div className={css(styleSheet.content)}>
					{visibleContacts.map((c, i) => (
						<EntityChip className={css(styleSheet.contact)} key={`${c.id}+${i}`} entity={c} readOnly={true} />
					))}
					{overflowCount > 0 && (
						<span className={css(styleSheet.tag, styleSheet.overflow)}>&nbsp;{`+${overflowCount} more`}</span>
					)}
				</div>
			</div>
		);
	}
}
